//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.RedistribuceKPredaniListPage.ts      </Name>
//    <Description>                                                             </Description>
//    <Author>      Jiří Šindelka                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-01-04                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class RedistribuceKPredaniListPage extends GContentBase<PodDokSpisListBasePage>
    {
        // filtr seznamu
        model: Wfl.Interface.GRedistribuceKPredaniFilterDto;

        onContentReady() {
            PodDokSpisListBasePage.InitList(this);
            this.FrmFiltr = "red_pred";
            this.topActions.push(Wfl.ListAC.WflListBaseAC.CreateActionDetailDokSpis(this));
            this.subTaskActions.push(this.CreateActionSubtask(Wfl.Interface.TypSeznamuDokSpis.kPredaniVsem));
            this.subTaskActions.push(this.CreateActionSubtask(Wfl.Interface.TypSeznamuDokSpis.kPredaniSU));
            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);
            this.SetSubtask(Wfl.Interface.TypSeznamuDokSpis.kPredaniVsem);
        }

        CreateFilterForms() {
            var filterForm = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "", layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000" }); //RC 26285623 : Filtr balíků

            filterForm.addSection("")
            switch (this.TypSeznamu)
            {
                case Wfl.Interface.TypSeznamuDokSpis.kPredaniVsem:
                    filterForm.addSection("");
                    filterForm.addRow()
                        .addField("gcheck", { name: "TakeNaCeste", label: "jres:23900138" })//RC 23900138 : I dokumenty/spisy na cestě
                        .addField("gcheck", { name: "SmerovaneOdCizichStredisek", label: "jres:23900139" }); //RC 23900139 : Směřované od cizích středisek
                    filterForm.addRow().addField("gcheck", { name: "PovolitPrevzetiIAnalogovych", label: "jres:23900140" }); //RC 23900140 : Povolit převzetí i analogových (fyzických) dokumentů (a automaticky je označovat)
                    filterForm.addRow().addField("gcheck", { name: "AutomatickyOznacitDigitalni", label: "jres:23900141" }); //RC 23900141 : Při zobrazení přehledu automaticky označit digitální dokumenty a spisy bez analogové formy                  
                    break;

                case Wfl.Interface.TypSeznamuDokSpis.kPredaniSU:
                    filterForm.addSection("");
                    filterForm.addRow({ label: "" }).addField("gradio", {
                        name: "TypSubjektu", itemClass: "",
                        initialValue: this.model.TypSubjektu,
                        radios: [
                            { value: Gin.Interface.IxsType.IxsSu, label: 'jres:23900144' }, //RC 23900144 : od uzlu
                            { value: Gin.Interface.IxsType.IxsFun, label: 'jres:23900145' }, //RC 23900145 : od osoby
                        ],
                        change: function (event, input) {
                            //if (input.value) {
                            //    if (that.defaultForm) {
                            //        that.defaultForm.findFields(fieldNames.referent).gfield("option", "disabled", input.value != 1);
                            //        that.defaultForm.findFields(fieldNames.extSubject).gfield("option", "disabled", input.value == 1);
                            //    }
                            //}
                        }
                    })
                    filterForm.addPrefab(Gordic.Gin.Prefabs.GSuFunRef(
                        {
                            name: "Predavajici",
                            model: "model.Predavajici.ixs_su=value.ixs_su;model.Predavajici.ixs_fun=value.ixs_fun",
                            serverFilters: {
                                aktivita: [100],
                            },
                            change: function (ev, data) {
                                //that.SuFunRefChange(data.value);
                            }
                        },
                        // 26.03.2020 - TFeik
                        // Doplněn příznak zda se funkce používá v redistribuci / předání.
                        undefined,
                        {
                            modPredani: true
                        }));
                    filterForm.addRow()
                        .addField("gcheck", { name: "SmerovatMeOsobe", label: "jres:23900142" })//RC 23900142 : Směřovat mé osobě
                        .addField("gcheck", { name: "PredatNaOsobu", label: "jres:23900143", change: (ev, obj) => { this.PredatNaOsobu = obj.value; } }); //RC 23900143 : Předat na osobu

                    break;
            }
            return [filterForm];
        }

        SetSubtask(typ: Wfl.Interface.TypSeznamuDokSpis) {
            this.TypSeznamu = typ;   
            this.CreateList();
            //WflZasilkyListBaseAC.EnabledAction(this);
        }

        CreateList() {
            if (this.filterForm) this.filterForm.remove();
            var that = this;
            // samotná definice gfilterpanelu
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {
                    that.LoadData(obj.filter);
                }).gfilterpanel({
                    forms: this.CreateFilterForms(), // poleFormu ktere budou pouzity pro podminky
                    // 01.03.2021 - TFeik
                    // Nahrazení obsolete parametrů.
                    filterViewMode: FilterViewMode.Simple,
                    //simpleMode: true,
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                });

            Wfl.ListAC.DokSpisListBaseAC.CreateGridDokSpis(this);
            this.filterForm.gfilterpanel("applyFilter", this.model, !this.NacistSeznamPriOtevreni)
        }

        CreateActionSubtask(typ: Wfl.Interface.TypSeznamuDokSpis): GAction
        {
            var l_caption = "";
            switch (typ)
            {
                case Wfl.Interface.TypSeznamuDokSpis.kPredaniVsem:
                    l_caption = "jres:23900146"; //RC 23900146 : Všem SU
                    break;
                case Wfl.Interface.TypSeznamuDokSpis.kPredaniSU:
                    l_caption = "jres:23900147"; //RC 23900147 : Podatelna a výpravna
                    break;                
            }

            var that = this;
            var action = new GAction({
                name: Gin.Globals.Enums.ActionsName.Subtask + typ,
                caption: l_caption,
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.AlwaysEnabled,
                run: function (ev, ctx) {
                    that.SetSubtask(typ);
                }
            });
            return action;
        }

        LoadData(filtr?: Wfl.Interface.GRedistribuceKPredaniFilterDto) {
            var that = this;
            Gin.Globals.ShowWaitLoadData(this);
            this.model = $.extend({}, this.model, filtr);
            if (this.model)
            {
                if (this.TypSeznamu == Wfl.Interface.TypSeznamuDokSpis.kPredaniVsem) {
                    this.call<Wfl.Interface.DokSpisListDto[]>("LoadDataVsemSU", { model: this.model })
                        .done(function (data) {
                            var view = new Gordic.Data.View(data, { key: that.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                            Wfl.ListAC.WflListBaseAC.ResolveResultData(that, data);
                            //that.mainGrid.ggrid("setData", view);
                            if (that.ResultType = Gin.Interface.TypVysledkuOperace.ProvedenoSUpozornenim) {
                                Wfl.AC.WflBaseAC.ShowFlashByContentInfo(that);
                            }
                        })
                        .always(function () {
                            Gordic.Wfl.ListAC.WflListBaseAC.AfterLoadData(that);
                        });
                }
                else
                {
                    this.call<Wfl.Interface.DokSpisListDto[]>("LoadDataVsemSU", { model: this.model })
                        .done(function (data) {
                            var view = new Gordic.Data.View(data, { key: that.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                            Wfl.ListAC.WflListBaseAC.ResolveResultData(that, data);
                            //that.mainGrid.ggrid("setData", view);
                            if (that.ResultType = Gin.Interface.TypVysledkuOperace.ProvedenoSUpozornenim) {
                                Wfl.AC.WflBaseAC.ShowFlashByContentInfo(that);
                            }
                            //  } catch (e) { console.log("e", e) }
                        })
                        .always(function () {
                            Gordic.Wfl.ListAC.WflListBaseAC.AfterLoadData(that);
                        });
                }
            }
        }

        ReloadData() {
            this.LoadData(this.model);
        }
    }
};
